var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMailBlueDark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 10.667,
    viewBox: "0 0 16 10.667",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#5539CB;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1.51,5.143,8.177,8.724a1.922,1.922,0,0,0,1.611,0l6.667-3.581C16.889,4.909,17.3,4,16.5,4H1.463C.666,4,1.076,4.909,1.51,5.143ZM16.656,7.1l-6.868,3.58a1.515,1.515,0,0,1-.805.177,1.515,1.515,0,0,1-.805-.177c-.3-.158-6.34-3.324-6.834-3.58C1,6.919,1,7.132,1,7.3v6.483a1.082,1.082,0,0,0,.889.889H16.111A1.082,1.082,0,0,0,17,13.778V7.3C17,7.132,17,6.92,16.656,7.1Z",
    transform: "translate(-1 -4)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailBlueDark);
export default __webpack_public_path__ + "static/media/mail-blue-dark.921979dddaa9c302aa278cb051735f61.svg";
export { ForwardRef as ReactComponent };